export default __webpack_public_path__ + "static/gta_roofing_5-9f4b8c786754fb36352f650df20b51ad.jpg";